import {
  MEDIA_LIST_LOADING,
  GET_MEDIA_LIST,
  GET_MEDIA_LIST_ERROR,
  GET_MEDIA_BY_ID_LOADING,
  GET_MEDIA_BY_ID_SUCCESS,
  GET_MEDIA_BY_ID_ERROR,
  DELETEING_MEDIA,
  DELETE_MEDIA,
  DELETE_MEDIA_ERROR,
  DELETED_MEDIA_LIST_LOADING,
  GET_DELETED_MEDIA_LIST,
  GET_DELETED_MEDIA_LIST_ERROR,
  PERMA_DELETEING_MEDIA,
  PERMA_DELETE_MEDIA,
  PERMA_DELETE_MEDIA_ERROR,
  RESTORE_MEDIA_LIST_LOADING,
  RESTORE_MEDIA_LIST,
  RESTORE_MEDIA_LIST_ERROR
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: MEDIA_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carousel/carouselcontent/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_MEDIA_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_MEDIA_LIST_ERROR,
        payload: error.response,
      });
    });
};


export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_MEDIA_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carouselcontent/active/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_MEDIA_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_MEDIA_BY_ID_ERROR,
        payload: error.response,
      });
    });
};



export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_MEDIA_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carouselcontent/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_MEDIA_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_MEDIA_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_MEDIA,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/carouselcontent/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_MEDIA,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_MEDIA_ERROR,
        payload: error.response,
      })
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_MEDIA,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/carouselcontent/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_MEDIA,
        payload: response,
      })
      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_MEDIA_ERROR,
        payload: error.response,
      })
      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_MEDIA_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/carouselcontent/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_MEDIA_LIST,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_MEDIA_LIST_ERROR,
        payload: error.response,
      }) 
      message.error(error.response.data.message);
    });
};